<div class="map-container">
  @if (mapLoading()) {
    <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100 text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading map...</span>
      </div>
      <p class="mt-2">Loading map...</p>
    </div>
  }
  @if (mapError()) {
    <div
      class="alert alert-warning m-0 d-flex flex-column align-items-center justify-content-center w-100 h-100 text-center"
    >
      <i class="bi bi-exclamation-triangle"></i>
      Unable to load map: {{ mapError() }}
    </div>
  }
  <div id="map" [style.display]="mapLoading() || mapError() ? 'none' : 'block'"></div>
</div>
